/* eslint-disable */
import axiosInstance from 'api/axios';
import { APIResponse } from '../types';
import { BlogResponse } from './blogApi';

export interface FolderResponse {
  id: number;
  user_id: string;
  folder_name: string;
  limit_of_files: number;
  created_at: string;
  updated_at: string;
  user: null | any;
  blogs: BlogResponse[] | null;
}

export const folderService = {
  // Folder Operations
  createFolder: async (
    folderName: string
  ): Promise<APIResponse<FolderResponse>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/blogs/folders/',
      {
        folder_name: folderName,
      }
    );
    return response.data;
  },

  getAllFolders: async (): Promise<APIResponse<FolderResponse[]>> => {
    const response = await axiosInstance.private.get('/api/v1/blogs/folders/');
    return response.data;
  },

  updateFolder: async (
    folderId: number,
    folderName: string
  ): Promise<APIResponse<FolderResponse>> => {
    const response = await axiosInstance.private.put(
      `/api/v1/blogs/folders/${folderId}`,
      {
        folder_name: folderName,
      }
    );
    return response.data;
  },

  deleteFolder: async (folderId: number): Promise<APIResponse<void>> => {
    const response = await axiosInstance.private.delete(
      `/api/v1/blogs/folders/${folderId}`
    );
    return response.data;
  },

  getFolderFiles: async (
    folderId: number
  ): Promise<APIResponse<BlogResponse[]>> => {
    const response = await axiosInstance.private.get(
      `/api/v1/blogs/folders/${folderId}/files`
    );
    return response.data;
  },
};
